import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import Layout from '../components/layout'
import Job from '../components/job'
import { Link } from 'gatsby'

class JobBoardTemplate extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const siteURL = get(this, 'props.data.site.siteMetadata.url')
    var posts = get(this, 'props.data.allAirtable.edges')
    var categories = get(this, 'props.data.categories.edges')
    const slug = get(this, 'props.pageContext.slug')
    const color = '#d3e8e1'
    const category = 'Job Board'
    const title = 'Job Board for Underrepresented Folks in Tech'
    const description =
      'Where companies are transparent about their Diversity & Inclusion efforts'
    const image = 'https://dl.airtable.com/VPbCohpQRMK22UDOCdvf_full_2.png'

    if (!posts) {
      posts = []
    }
    return (
      <Layout location={this.props.location} style={{ backgroundColor: color }}>
        <Helmet
          htmlAttributes={{ lang: 'en' }}
          meta={[
            { name: 'description', content: description },
            { property: 'og:title', content: title },
            {
              property: 'og:description',
              content: description,
            },
            {
              name: 'twitter:title',
              content: title,
            },
            {
              name: 'twitter:description',
              content: description,
            },
          ]}
          title={siteTitle + ' ' + category}
        />

        <div className="max-w-screen-xl mx-auto md:p-12 md:pt-4">
          <div className="p-4 text-center">
            <h2 className="text-2xl font-extrabold leading-10 tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:text-5xl">
              Job Board
              <br />
              <span className="text-teal-500">
                for underrepresented folks in tech
              </span>
            </h2>
            <p className="max-w-md mx-auto mt-3 text-base leading-5 text-gray-600 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
              A job board where companies are transparent about their Diversity
              & Inclusion efforts
            </p>
            <Link to="/post-a-job" className="block text-black underline">
              Hiring? Reach 7500 email subscribers. Post a Job →
            </Link>
          </div>
          <div className="max-w-xl pl-6 pr-6 mx-auto text-center sm:max-w-none md:max-w-none lg:max-w-none">
            <Link
              to="/job-board/"
              className="inline-flex items-center px-4 py-2 m-2 text-base leading-6 text-gray-700 no-underline transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:bg-teal-500 hover:text-white focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 hover:border-black"
              rel="noopener noreferrer"
            >
              All
            </Link>

            {categories.map(({ node }) => {
              return (
                <Link
                  to={'/job-board/' + node.data.Slug}
                  className={
                    'inline-flex items-center px-4 py-2 border border-gray-300 text-base leading-6 rounded-md focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 m-2 no-underline  no-underline' +
                    (slug == node.data.Slug
                      ? ' bg-teal-500 text-white'
                      : ' text-gray-700 bg-white hover:bg-teal-500 hover:text-white hover:border-black')
                  }
                  rel="noopener noreferrer"
                >
                  {node.data.Name}
                </Link>
              )
            })}
          </div>
          <div
            className={
              slug == 'entry-level' ? 'italic text-center pt-6 pb-4' : 'hidden'
            }
          >
            These roles were indicated by the company that entry-level folks can
            apply to these roles.
          </div>
          <div
            className={
              slug == 'mid-level' ? 'italic text-center pt-6 pb-4' : 'hidden'
            }
          >
            These roles were indicated by the company that mid-level folks can
            apply to these roles.
          </div>

          <div
            className={
              slug == 'senior-level' ? 'italic text-center pt-6 pb-4' : 'hidden'
            }
          >
            These roles were indicated by the company that senior-level folks
            can apply to these roles.
          </div>

          <div className="flex flex-wrap justify-center p-6">
            {posts.map(({ node }) => {
              if (
                !node.data.Preview &
                (node.data.Show == 1) &
                !node.data.Filled &
                !node.data.Paused &
                (node.data.Days_Since <= 30)
              ) {
                return (
                  <Job
                    key={node.id}
                    data={node.data}
                    color={color}
                    id={node.id}
                    isDetail={false}
                    url={siteURL}
                  />
                )
              }
            })}
          </div>
        </div>
      </Layout>
    )
  }
}

export default JobBoardTemplate

export const pageQuery = graphql`
  query($category: String!) {
    site {
      siteMetadata {
        title
        url
      }
    }

    categories: allAirtable(
      filter: { table: { eq: "Job Board - Categories" } }
      sort: { fields: [data___Order], order: ASC }
    ) {
      edges {
        node {
          id
          data {
            Name
            Slug
            Order
          }
        }
      }
    }

    allAirtable(
      filter: { table: { eq: "Jobs" }, data: { Category: { eq: $category } } }
      sort: { fields: [data___Days_Since], order: [ASC] }
    ) {
      edges {
        node {
          id
          data {
            Job_ID
            Name
            Role
            Logo {
              url
            }
            Website
            Location
            Tagline
            Description
            Description_in_HTML
            Application_Close_Date
            Number_of_Team_Members
            Number_of_Women
            Number_of_People_of_Color
            Number_of_LGBTQIA_Individuals
            Number_of_Disabled_Individuals
            Interview_Process
            Diversity
            Salary_Range
            Featured
            Approved
            Created_Date
            Email
            Slug
            Days_Since
            Show
            Category
            Company {
              data {
                Name
                Logo {
                  thumbnails {
                    large {
                      url
                    }
                  }
                }
                Company_ID
                Tagline
                Number_of_Team_Members
                Number_of_Women
                Number_of_People_of_Color
                Number_of_LGBTQIA_Individuals
                Number_of_Disabled_Individuals
                Diversity
                Number_of_Black_people
                Number_of_Latinx_people
                Number_of_Indigenous_people
              }
            }
          }
        }
      }
    }
  }
`
